export const OrderMachineStatus = {
  PAID: "PAID",
  CANCELED: "CANCELED",
  PENDING: "PENDING",
}